module.exports = __webpack_public_path__ + "img/Trophy Cup Table01.cf24c2b0.jpg";